// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const MetadataHttpGetAssetsByAssetIdVersionsByVersionIdViewsByViewId =
  'MetadataHttpGetAssetsByAssetIdVersionsByVersionIdViewsByViewId' as const;
export const MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdVersionsByVersionIdViewsByViewId =
  'MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdVersionsByVersionIdViewsByViewId' as const;
export const MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId =
  'MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId' as const;
export const MetadataHttpPutAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId =
  'MetadataHttpPutAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId' as const;
export const MetadataHttpGetFields = 'MetadataHttpGetFields' as const;
export const MetadataHttpPostFields = 'MetadataHttpPostFields' as const;
export const MetadataHttpDeleteFieldsByFieldName =
  'MetadataHttpDeleteFieldsByFieldName' as const;
export const MetadataHttpGetFieldsByFieldName =
  'MetadataHttpGetFieldsByFieldName' as const;
export const MetadataHttpPatchFieldsByFieldName =
  'MetadataHttpPatchFieldsByFieldName' as const;
export const MetadataHttpPutFieldsByFieldName =
  'MetadataHttpPutFieldsByFieldName' as const;
export const MetadataHttpPostMappingFields =
  'MetadataHttpPostMappingFields' as const;
export const MetadataHttpGetMappingFieldsByFieldName =
  'MetadataHttpGetMappingFieldsByFieldName' as const;
export const MetadataHttpGetMappingOptions =
  'MetadataHttpGetMappingOptions' as const;
export const MetadataHttpGetSharesCustomActionsByContextByActionIdViews =
  'MetadataHttpGetSharesCustomActionsByContextByActionIdViews' as const;
export const MetadataHttpGetUserFields = 'MetadataHttpGetUserFields' as const;
export const MetadataHttpGetViews = 'MetadataHttpGetViews' as const;
export const MetadataHttpPostViews = 'MetadataHttpPostViews' as const;
export const MetadataHttpPostViewsReindex =
  'MetadataHttpPostViewsReindex' as const;
export const MetadataHttpDeleteViewsByViewId =
  'MetadataHttpDeleteViewsByViewId' as const;
export const MetadataHttpGetViewsByViewId =
  'MetadataHttpGetViewsByViewId' as const;
export const MetadataHttpPatchViewsByViewId =
  'MetadataHttpPatchViewsByViewId' as const;
export const MetadataHttpPutViewsByViewId =
  'MetadataHttpPutViewsByViewId' as const;
export const MetadataHttpPostViewsByViewIdReindex =
  'MetadataHttpPostViewsByViewIdReindex' as const;
export const MetadataHttpGetByObjectTypeCategories =
  'MetadataHttpGetByObjectTypeCategories' as const;
export const MetadataHttpPostByObjectTypeCategories =
  'MetadataHttpPostByObjectTypeCategories' as const;
export const MetadataHttpDeleteByObjectTypeCategoriesByName =
  'MetadataHttpDeleteByObjectTypeCategoriesByName' as const;
export const MetadataHttpGetByObjectTypeCategoriesByName =
  'MetadataHttpGetByObjectTypeCategoriesByName' as const;
export const MetadataHttpPutByObjectTypeCategoriesByName =
  'MetadataHttpPutByObjectTypeCategoriesByName' as const;
export const MetadataHttpGetByObjectTypeCategoriesByNameViews =
  'MetadataHttpGetByObjectTypeCategoriesByNameViews' as const;
export const MetadataHttpPutByObjectTypeContentViewsByViewId =
  'MetadataHttpPutByObjectTypeContentViewsByViewId' as const;
export const MetadataHttpPostByObjectTypeViewsByViewId =
  'MetadataHttpPostByObjectTypeViewsByViewId' as const;
export const MetadataHttpPutByObjectTypeViewsByViewId =
  'MetadataHttpPutByObjectTypeViewsByViewId' as const;
export const MetadataHttpGetByObjectTypeByObjectId =
  'MetadataHttpGetByObjectTypeByObjectId' as const;
export const MetadataHttpPutByObjectTypeByObjectId =
  'MetadataHttpPutByObjectTypeByObjectId' as const;
export const MetadataHttpGetByObjectTypeByObjectIdViewsByViewId =
  'MetadataHttpGetByObjectTypeByObjectIdViewsByViewId' as const;
export const MetadataHttpPutByObjectTypeByObjectIdViewsByViewId =
  'MetadataHttpPutByObjectTypeByObjectIdViewsByViewId' as const;

/**
 * Original schema `BulkMetadataCopySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-BulkMetadataCopySchema}
 */
export interface MetadataBulkMetadataCopySchema {
  object_ids_mapping: MetadataSegmentsCopyMapping[];
}
/**
 * Original schema `SegmentsCopyMapping`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-SegmentsCopyMapping}
 */
export interface MetadataSegmentsCopyMapping {
  destination_object_id: string;
  destination_version_id: string;
  source_object_id: string;
  source_version_id: string;
}
/**
 * Original schema `BulkMetadataDeleteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-BulkMetadataDeleteSchema}
 */
export interface MetadataBulkMetadataDeleteSchema {
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
}
/**
 * Original schema `CollectionMetadataValuesBatchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-CollectionMetadataValuesBatchSchema}
 */
export interface MetadataCollectionMetadataValuesBatchSchema {
  date_created?: string;
  date_modified?: string;
  include_assets: boolean;
  include_collections: boolean;
  metadata_values: {
    [k: string]: MetadataMetadataFieldValueSchema;
  };
  object_ids: string[];
  object_type?: string;
}
/**
 * Original schema `MetadataFieldValueSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldValueSchema}
 */
export interface MetadataMetadataFieldValueSchema {
  date_created?: string | null;
  field_values?: {
    [k: string]: unknown;
  }[];
  mode?: 'append' | 'delete' | 'overwrite';
}
/**
 * Original schema `CopySourceQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-CopySourceQueryParamsSchema}
 */
export interface MetadataCopySourceQueryParamsSchema {
  source_object_id?: string;
  source_object_type?: string;
  source_version_id?: string;
}
/**
 * Original schema `CreateMetadataValuesBatchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-CreateMetadataValuesBatchSchema}
 */
export interface MetadataCreateMetadataValuesBatchSchema {
  asset_id?: string;
  date_created?: string;
  date_modified?: string;
  metadata_values_object_id_mapping: MetadataMetadataValuesObjectId[];
  object_ids: string[];
  object_type?: string;
}
/**
 * Original schema `MetadataValuesObjectId`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataValuesObjectId}
 */
export interface MetadataMetadataValuesObjectId {
  id: string;
  metadata_values: {
    [k: string]: MetadataMetadataFieldValueSchema;
  };
}
/**
 * Original schema `ExternalSourceFieldOptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-ExternalSourceFieldOptionsSchema}
 */
export interface MetadataExternalSourceFieldOptionsSchema {
  label?: string;
  value?: string;
}
/**
 * Original schema `FacetFieldNamesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-FacetFieldNamesSchema}
 */
export interface MetadataFacetFieldNamesSchema {
  objects?: string[];
}
/**
 * Original schema `FieldOptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-FieldOptionsSchema}
 */
export interface MetadataFieldOptionsSchema {
  label?: string;
  value?: string;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-ListObjectsSchema}
 */
export interface MetadataListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `MetadataCategoriesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataCategoriesSchema}
 */
export interface MetadataMetadataCategoriesSchema {
  objects?: MetadataMetadataCategory[];
}
/**
 * Original schema `MetadataCategory`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataCategory}
 */
export interface MetadataMetadataCategory {
  date_created?: string;
  date_modified?: string;
  label: string;
  name: string;
  object_type?: string;
  view_ids?: string[];
  views?: MetadataMetadataView[];
}
/**
 * Original schema `MetadataView`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataView}
 */
export interface MetadataMetadataView {
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  name: string;
  view_fields: MetadataMetadataField[];
}
/**
 * Original schema `MetadataField`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataField}
 */
export interface MetadataMetadataField {
  /**
   * When true, AI metadata generation (AiME) never fills this field. Its saved value may still be used as context when generating other fields.
   */
  ai_generation_excluded?: boolean;
  /**
   * LLM prompt override used when generating values for this field. If unset, the LLM prompt falls back to `description`.
   */
  ai_prompt_description?: string | null;
  auto_set?: boolean | null;
  date_created?: string;
  date_modified?: string;
  description?: string;
  external_id?: string;
  field_type: string;
  hide_if_not_set?: boolean | null;
  is_block_field?: boolean;
  is_warning_field?: boolean;
  label: string;
  mapped_field_name?: string;
  max_value?: number;
  min_value?: number;
  multi?: boolean;
  name: string;
  options?: MetadataFieldOptionsSchema[];
  read_only?: boolean | null;
  representative?: boolean;
  required?: boolean | null;
  sortable?: boolean;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
  use_as_facet?: boolean;
}
/**
 * Original schema `MetadataCategorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataCategorySchema}
 */
export interface MetadataMetadataCategorySchema {
  date_created?: string;
  date_modified?: string;
  label: string;
  name: string;
  object_type?: string;
  view_ids?: string[];
  views?: MetadataMetadataView[];
}
/**
 * Original schema `MetadataFieldBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldBaseSchema}
 */
export interface MetadataMetadataFieldBaseSchema {
  /**
   * When true, AI metadata generation (AiME) never fills this field. Its saved value may still be used as context when generating other fields.
   */
  ai_generation_excluded?: boolean;
  /**
   * LLM prompt override used when generating values for this field. If unset, the LLM prompt falls back to `description`.
   */
  ai_prompt_description?: string | null;
  auto_set?: boolean | null;
  date_created?: string;
  date_modified?: string;
  description?: string;
  external_id?: string;
  field_type: string;
  hide_if_not_set?: boolean | null;
  is_block_field?: boolean;
  is_warning_field?: boolean;
  mapped_field_name?: string;
  max_value?: number;
  min_value?: number;
  multi?: boolean;
  options?: MetadataFieldOptionsSchema[];
  read_only?: boolean | null;
  representative?: boolean;
  required?: boolean | null;
  sortable?: boolean;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
  use_as_facet?: boolean;
}
/**
 * Original schema `MetadataFieldCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldCreateSchema}
 */
export interface MetadataMetadataFieldCreateSchema {
  /**
   * When true, AI metadata generation (AiME) never fills this field. Its saved value may still be used as context when generating other fields.
   */
  ai_generation_excluded?: boolean;
  /**
   * LLM prompt override used when generating values for this field. If unset, the LLM prompt falls back to `description`.
   */
  ai_prompt_description?: string | null;
  auto_set?: boolean | null;
  date_created?: string;
  date_modified?: string;
  description?: string;
  external_id?: string;
  field_type: string;
  hide_if_not_set?: boolean | null;
  is_block_field?: boolean;
  is_warning_field?: boolean;
  label: string;
  mapped_field_name?: string;
  max_value?: number;
  min_value?: number;
  multi?: boolean;
  name: string;
  options?: MetadataFieldOptionsSchema[];
  read_only?: boolean | null;
  representative?: boolean;
  required?: boolean | null;
  sortable?: boolean;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
  use_as_facet?: boolean;
}
/**
 * Original schema `MetadataFieldMappingOptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldMappingOptionSchema}
 */
export interface MetadataMetadataFieldMappingOptionSchema {
  name: string;
}
/**
 * Original schema `MetadataFieldMappingOptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldMappingOptionsSchema}
 */
export interface MetadataMetadataFieldMappingOptionsSchema {
  objects: MetadataMetadataFieldMappingOptionSchema[];
}
/**
 * Original schema `MetadataFieldMappingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldMappingSchema}
 */
export interface MetadataMetadataFieldMappingSchema {
  field_type?: string;
  mapped_field_name: string;
  name: string;
}
/**
 * Original schema `MetadataFieldMappingUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldMappingUpdateSchema}
 */
export interface MetadataMetadataFieldMappingUpdateSchema {
  field_type?: string;
  mapped_field_name: string;
  name?: string;
}
/**
 * Original schema `MetadataFieldMappingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldMappingsSchema}
 */
export interface MetadataMetadataFieldMappingsSchema {
  objects?: MetadataMetadataFieldMappingSchema[];
}
/**
 * Original schema `MetadataFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldSchema}
 */
export interface MetadataMetadataFieldSchema {
  /**
   * When true, AI metadata generation (AiME) never fills this field. Its saved value may still be used as context when generating other fields.
   */
  ai_generation_excluded?: boolean;
  /**
   * LLM prompt override used when generating values for this field. If unset, the LLM prompt falls back to `description`.
   */
  ai_prompt_description?: string | null;
  auto_set?: boolean | null;
  date_created?: string;
  date_modified?: string;
  description?: string;
  external_id?: string;
  field_type: string;
  hide_if_not_set?: boolean | null;
  is_block_field?: boolean;
  is_warning_field?: boolean;
  label: string;
  mapped_field_name?: string;
  max_value?: number;
  min_value?: number;
  multi?: boolean;
  name: string;
  options?: MetadataFieldOptionsSchema[];
  read_only?: boolean | null;
  representative?: boolean;
  required?: boolean | null;
  sortable?: boolean;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
  use_as_facet?: boolean;
}
/**
 * Original schema `MetadataFieldsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldsSchema}
 */
export interface MetadataMetadataFieldsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: MetadataMetadataFieldSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `MetadataValuesBatchSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataValuesBatchSchema}
 */
export interface MetadataMetadataValuesBatchSchema {
  date_created?: string;
  date_modified?: string;
  metadata_values: {
    [k: string]: MetadataMetadataFieldValueSchema;
  };
  object_ids: string[];
  object_type?: string;
}
/**
 * Original schema `MetadataValuesObjectIdSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataValuesObjectIdSchema}
 */
export interface MetadataMetadataValuesObjectIdSchema {
  id: string;
  metadata_values: {
    [k: string]: MetadataMetadataFieldValueSchema;
  };
}
/**
 * Original schema `MetadataValuesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataValuesSchema}
 */
export interface MetadataMetadataValuesSchema {
  date_created?: string | null;
  date_modified?: string | null;
  job_id?: string;
  metadata_values: {
    [k: string]: MetadataMetadataFieldValueSchema;
  };
  object_id?: string;
  object_type?: string;
  version_id?: string;
}
/**
 * Original schema `MetadataViewCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewCreateSchema}
 */
export interface MetadataMetadataViewCreateSchema {
  description?: string | null;
  id?: string;
  name: string;
  view_fields: MetadataMetadataViewField[];
  write_access_for_everyone?: boolean;
}
/**
 * Original schema `MetadataViewField`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewField}
 */
export interface MetadataMetadataViewField {
  ai_generation_excluded?: boolean;
  auto_set?: boolean | null;
  hide_if_not_set?: boolean | null;
  label?: string | null;
  mapped_field_name?: string;
  name: string;
  options?: MetadataFieldOptionsSchema[] | null;
  read_only?: boolean | null;
  required?: boolean | null;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
}
/**
 * Original schema `MetadataViewFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewFieldSchema}
 */
export interface MetadataMetadataViewFieldSchema {
  ai_generation_excluded?: boolean;
  auto_set?: boolean | null;
  hide_if_not_set?: boolean | null;
  label?: string | null;
  mapped_field_name?: string;
  name: string;
  options?: MetadataFieldOptionsSchema[] | null;
  read_only?: boolean | null;
  required?: boolean | null;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
}
/**
 * Original schema `MetadataViewForListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewForListSchema}
 */
export interface MetadataMetadataViewForListSchema {
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  name: string;
  view_fields: MetadataMetadataViewFieldSchema[];
}
/**
 * Original schema `MetadataViewInputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewInputSchema}
 */
export interface MetadataMetadataViewInputSchema {
  description?: string | null;
  id?: string;
  name: string;
  view_fields: MetadataMetadataViewFieldSchema[];
}
/**
 * Original schema `MetadataViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewSchema}
 */
export interface MetadataMetadataViewSchema {
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id?: string;
  name: string;
  view_fields: MetadataMetadataFieldSchema[];
}
/**
 * Original schema `MetadataViewsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewsSchema}
 */
export interface MetadataMetadataViewsSchema {
  objects?: MetadataMetadataViewForListSchema[];
}
/**
 * Original schema `ReindexMetadataViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-ReindexMetadataViewSchema}
 */
export interface MetadataReindexMetadataViewSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `SegmentsCopyMappingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-SegmentsCopyMappingSchema}
 */
export interface MetadataSegmentsCopyMappingSchema {
  destination_object_id: string;
  destination_version_id: string;
  source_object_id: string;
  source_version_id: string;
}
/**
 * Original schema `MetadataValuesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataValuesSchema}
 */
export interface MetadataMetadataValuesSchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  job_id?: string | null;
  metadata_values: {
    [k: string]: MetadataMetadataFieldValueSchema;
  };
  object_id?: string | null;
  object_type?: string | null;
  version_id?: string | null;
}
/**
 * Original schema `MetadataFieldsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldsSchema}
 */
export interface MetadataMetadataFieldsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: MetadataMetadataFieldSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `MetadataFieldSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldSchema}
 */
export interface MetadataMetadataFieldSchemaNullable {
  /**
   * When true, AI metadata generation (AiME) never fills this field. Its saved value may still be used as context when generating other fields.
   */
  ai_generation_excluded?: boolean | null;
  /**
   * LLM prompt override used when generating values for this field. If unset, the LLM prompt falls back to `description`.
   */
  ai_prompt_description?: string | null;
  auto_set?: boolean | null;
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  external_id?: string | null;
  field_type: string;
  hide_if_not_set?: boolean | null;
  is_block_field?: boolean | null;
  is_warning_field?: boolean | null;
  label: string;
  mapped_field_name?: string | null;
  max_value?: number | null;
  min_value?: number | null;
  multi?: boolean | null;
  name: string;
  options?: MetadataFieldOptionsSchema[] | null;
  read_only?: boolean | null;
  representative?: boolean | null;
  required?: boolean | null;
  sortable?: boolean | null;
  /**
   * Will be used to upload MetadataField's `options`. Cannot be set or used as long as `options` are set.  **Example**: The value is `https://external-url.com/foo/`. In that case `GET` request will be sent to `https://external-url.com/foo/?user_id=uuid1&view_id=uuid1&field_name=bar&view_name=user_view&system_domain_id=uuid1`. Please note that some query parameters were added by *iconik* to get values that were predefined in your system for each user [user_id] and view [view_id]. Metadata field name [field_name], view's name [view_name] and system domain identifier [system_domain_id] will be also passed in each request. *iconik* will successfully parse the response from that URL if it will be sent in JSON formatted string: `{"bar": [{"value": "1", "label": "1st"}, {"value": "2", "label": "2nd"}]}`
   */
  source_url?: string | null;
  use_as_facet?: boolean | null;
}
/**
 * Original schema `MetadataFieldMappingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataFieldMappingSchema}
 */
export interface MetadataMetadataFieldMappingSchemaNullable {
  field_type?: string | null;
  mapped_field_name: string;
  name: string;
}
/**
 * Original schema `MetadataViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewSchema}
 */
export interface MetadataMetadataViewSchemaWithId {
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id: string;
  name: string;
  view_fields: MetadataMetadataFieldSchema[];
}
/**
 * Original schema `MetadataViewSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewSchema}
 */
export interface MetadataMetadataViewSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string;
  name: string;
  view_fields: MetadataMetadataFieldSchema[];
}
/**
 * Original schema `MetadataViewsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewsSchema}
 */
export interface MetadataMetadataViewsSchemaWithId {
  objects: MetadataMetadataViewForListSchemaWithIdNullable[];
}
/**
 * Original schema `MetadataViewForListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewForListSchema}
 */
export interface MetadataMetadataViewForListSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  description?: string | null;
  id: string;
  name: string;
  view_fields: MetadataMetadataViewFieldSchema[];
}
/**
 * Original schema `MetadataViewForListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataViewForListSchema}
 */
export interface MetadataMetadataViewForListSchemaWithId {
  date_created?: string;
  date_modified?: string;
  description?: string | null;
  id: string;
  name: string;
  view_fields: MetadataMetadataViewFieldSchema[];
}
/**
 * Original schema `MetadataCategoriesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataCategoriesSchema}
 */
export interface MetadataMetadataCategoriesSchemaWithId {
  objects: MetadataMetadataCategoryNullable[];
}
/**
 * Original schema `MetadataCategory`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataCategory}
 */
export interface MetadataMetadataCategoryNullable {
  date_created?: string | null;
  date_modified?: string | null;
  label: string;
  name: string;
  object_type?: string | null;
  view_ids?: string[] | null;
  views?: MetadataMetadataView[] | null;
}
/**
 * Original schema `MetadataCategorySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#model-MetadataCategorySchema}
 */
export interface MetadataMetadataCategorySchemaNullable {
  date_created?: string | null;
  date_modified?: string | null;
  label: string;
  name: string;
  object_type?: string | null;
  view_ids?: string[] | null;
  views?: MetadataMetadataView[] | null;
}

export interface MetadataHttpGetAssetsByAssetIdVersionsByVersionIdViewsByViewIdQuery {
  reencode_values_to_string?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/versions/{version_id}/views/{view_id}/`
 *
 * Get asset metadata by asset ID, version ID and view ID
 *
 * Required roles:
 *  - can_read_metadata_values
 *
 * Responses
 * - 200 - Returns metadata values for object and view if it exists
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata values for this object and view doesn't exist
 *
 * Response {@link MetadataMetadataValuesSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_assets__asset_id__versions__version_id__views__view_id__}
 */
export const httpGetAssetsByAssetIdVersionsByVersionIdViewsByViewId = (
  assetId: string,
  versionId: string,
  viewId: string,
  query?: MetadataHttpGetAssetsByAssetIdVersionsByVersionIdViewsByViewIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetAssetsByAssetIdVersionsByVersionIdViewsByViewId,
  method: httpMethod.get,
  url: `/API/metadata/v1/assets/${encodeURIComponent(assetId)}/versions/${encodeURIComponent(versionId)}/views/${encodeURIComponent(viewId)}/`,
  params: { assetId, versionId, viewId },
  query,
  headers,
});

/**
 * `GET /v1/assets/{asset_id}/{object_type}/{object_id}/versions/{version_id}/views/{view_id}/`
 *
 * Get asset metadata by object type, object ID, version ID and view ID
 *
 * Required roles:
 *  - can_read_metadata_values
 *
 * Responses
 * - 200 - Returns metadata values for object and view if it exists
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata values for this object and view doesn't exist
 *
 * Response {@link MetadataMetadataValuesSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_assets__asset_id___object_type___object_id__versions__version_id__views__view_id__}
 * @deprecated
 */
export const httpGetAssetsByAssetIdByObjectTypeByObjectIdVersionsByVersionIdViewsByViewId =
  (
    assetId: string,
    objectType: string,
    objectId: string,
    versionId: string,
    viewId: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdVersionsByVersionIdViewsByViewId,
    method: httpMethod.get,
    url: `/API/metadata/v1/assets/${encodeURIComponent(assetId)}/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/versions/${encodeURIComponent(versionId)}/views/${encodeURIComponent(viewId)}/`,
    params: { assetId, objectType, objectId, versionId, viewId },
    headers,
  });

export interface MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdViewsByViewIdQuery {
  reencode_values_to_string?: boolean;
}

/**
 * `GET /v1/assets/{asset_id}/{object_type}/{object_id}/views/{view_id}/`
 *
 * Get asset metadata by object type, object ID and view ID
 *
 * Required roles:
 *  - can_read_metadata_values
 *
 * Responses
 * - 200 - Returns metadata values for object and view if it exists
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata values for this object and view doesn't exist
 *
 * Response {@link MetadataMetadataValuesSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_assets__asset_id___object_type___object_id__views__view_id__}
 */
export const httpGetAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId = (
  assetId: string,
  objectType: string,
  objectId: string,
  viewId: string,
  query?: MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdViewsByViewIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId,
  method: httpMethod.get,
  url: `/API/metadata/v1/assets/${encodeURIComponent(assetId)}/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/views/${encodeURIComponent(viewId)}/`,
  params: { assetId, objectType, objectId, viewId },
  query,
  headers,
});

export interface MetadataHttpPutAssetsByAssetIdByObjectTypeByObjectIdViewsByViewIdQuery {
  ignore_unchanged?: boolean;
}

/**
 * `PUT /v1/assets/{asset_id}/{object_type}/{object_id}/views/{view_id}/`
 *
 * Edit view metadata values for sub-objects of an asset (Such as segments)
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 200 - Returns created metadata values for object and view
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * Response {@link MetadataMetadataValuesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1_assets__asset_id___object_type___object_id__views__view_id__}
 */
export const httpPutAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId = (
  assetId: string,
  objectType: string,
  objectId: string,
  viewId: string,
  body: MetadataMetadataValuesSchema,
  query?: MetadataHttpPutAssetsByAssetIdByObjectTypeByObjectIdViewsByViewIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutAssetsByAssetIdByObjectTypeByObjectIdViewsByViewId,
  method: httpMethod.put,
  url: `/API/metadata/v1/assets/${encodeURIComponent(assetId)}/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/views/${encodeURIComponent(viewId)}/`,
  params: { assetId, objectType, objectId, viewId },
  body,
  query,
  headers,
});

export interface MetadataHttpGetFieldsQuery {
  /**
   * The number of items for each page (Default 5000)
   */
  per_page?: number;
  /**
   * If your request returns per_page entries, send the last value of "name" to fetch next page
   */
  last_field_name?: string;
  /**
   * A comma separated list of fieldnames For example - first_name,last_name,salary
   */
  filter?: string;
}

/**
 * `GET /v1/fields/`
 *
 * List the fields defined in the system
 *
 * Required roles:
 *  - can_read_metadata_fields
 *
 * Responses
 * - 200 - Returns a list of metadata fields
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MetadataMetadataFieldsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_fields_}
 */
export const httpGetFields = (
  query?: MetadataHttpGetFieldsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetFields,
  method: httpMethod.get,
  url: '/API/metadata/v1/fields/',

  query,
  headers,
});

/**
 * `POST /v1/fields/`
 *
 * Create a new field
 *
 * Required roles:
 *  - can_write_metadata_fields
 *
 * Responses
 * - 201 - Returns a created field
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 409 - A field with the same name already exists
 *
 * Response {@link MetadataMetadataFieldSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1_fields_}
 */
export const httpPostFields = (
  body: MetadataMetadataFieldCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostFields,
  method: httpMethod.post,
  url: '/API/metadata/v1/fields/',

  body,
  headers,
});

/**
 * `DELETE /v1/fields/{field_name}/`
 *
 * Delete a particular field by name
 *
 * Required roles:
 *  - can_delete_metadata_fields
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata field doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/delete_v1_fields__field_name__}
 */
export const httpDeleteFieldsByFieldName = (
  fieldName: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpDeleteFieldsByFieldName,
  method: httpMethod.delete,
  url: `/API/metadata/v1/fields/${encodeURIComponent(fieldName)}/`,
  params: { fieldName },
  headers,
});

/**
 * `GET /v1/fields/{field_name}/`
 *
 * Returns a particular field by name
 *
 * Required roles:
 *  - can_read_metadata_fields
 *
 * Responses
 * - 200 - Returns a field
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata field doesn't exist
 *
 * Response {@link MetadataMetadataFieldSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_fields__field_name__}
 */
export const httpGetFieldsByFieldName = (
  fieldName: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetFieldsByFieldName,
  method: httpMethod.get,
  url: `/API/metadata/v1/fields/${encodeURIComponent(fieldName)}/`,
  params: { fieldName },
  headers,
});

export type MetadataMetadataFieldSchemaPartial =
  Partial<MetadataMetadataFieldSchema>;

/**
 * `PATCH /v1/fields/{field_name}/`
 *
 * Update field by name
 *
 * Required roles:
 *  - can_write_metadata_fields
 *
 * Responses
 * - 200 - Returns an updated field
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata field doesn't exist
 *
 * Response {@link MetadataMetadataFieldSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/patch_v1_fields__field_name__}
 */
export const httpPatchFieldsByFieldName = (
  fieldName: string,
  body: MetadataMetadataFieldSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPatchFieldsByFieldName,
  method: httpMethod.patch,
  url: `/API/metadata/v1/fields/${encodeURIComponent(fieldName)}/`,
  params: { fieldName },
  body,
  headers,
});

/**
 * `PUT /v1/fields/{field_name}/`
 *
 * Update field by name
 *
 * Required roles:
 *  - can_write_metadata_fields
 *
 * Responses
 * - 200 - Returns an updated field
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata field doesn't exist
 *
 * Response {@link MetadataMetadataFieldSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1_fields__field_name__}
 */
export const httpPutFieldsByFieldName = (
  fieldName: string,
  body: MetadataMetadataFieldSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutFieldsByFieldName,
  method: httpMethod.put,
  url: `/API/metadata/v1/fields/${encodeURIComponent(fieldName)}/`,
  params: { fieldName },
  body,
  headers,
});

/**
 * `POST /v1/mapping/fields/`
 *
 * Create a new metadata field mapping
 *
 * Required roles:
 *  - can_read_metadata_fields
 *
 * Responses
 * - 201 - Returns a created field mapping
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata field doesn't exist
 *
 * Response {@link MetadataMetadataFieldMappingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1_mapping_fields_}
 */
export const httpPostMappingFields = (
  body: MetadataMetadataFieldMappingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostMappingFields,
  method: httpMethod.post,
  url: '/API/metadata/v1/mapping/fields/',

  body,
  headers,
});

/**
 * `GET /v1/mapping/fields/{field_name}/`
 *
 * Get the metadata field mapping
 *
 * Required roles:
 *  - can_read_metadata_fields
 *
 * Responses
 * - 200 - Returns the metadata field mapping
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata field mapping doesn't exist
 *
 * Response {@link MetadataMetadataFieldMappingSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_mapping_fields__field_name__}
 */
export const httpGetMappingFieldsByFieldName = (
  fieldName: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetMappingFieldsByFieldName,
  method: httpMethod.get,
  url: `/API/metadata/v1/mapping/fields/${encodeURIComponent(fieldName)}/`,
  params: { fieldName },
  headers,
});

/**
 * `GET /v1/mapping/options/`
 *
 * List the metadata field mapping options
 *
 * Required roles:
 *  - can_read_metadata_fields
 *
 * Responses
 * - 200 - Returns a list of metadata field mapping options
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MetadataMetadataFieldMappingOptionsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_mapping_options_}
 */
export const httpGetMappingOptions = (headers?: IconikApiHeaders) => ({
  id: MetadataHttpGetMappingOptions,
  method: httpMethod.get,
  url: '/API/metadata/v1/mapping/options/',

  headers,
});

export interface MetadataHttpGetSharesCustomActionsByContextByActionIdViewsHeader
  extends IconikApiHeaders {
  'Share-ID': string;
  'Share-User-ID': string;
}

/**
 * `GET /v1/shares/custom_actions/{context}/{action_id}/views/`
 *
 * Returns a particular view for a shared custom action context
 *
 *
 * Responses
 * - 200 - Returns a view
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Custom actions not enabled for this share
 * - 404 - Metadata view doesn't exist
 * - 503 - Failed to retrieve metadata view from search index
 *
 * Response {@link MetadataMetadataViewSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_shares_custom_actions__context___action_id__views_}
 */
export const httpGetSharesCustomActionsByContextByActionIdViews = (
  context: string,
  actionId: string,
  headers: MetadataHttpGetSharesCustomActionsByContextByActionIdViewsHeader,
) => ({
  id: MetadataHttpGetSharesCustomActionsByContextByActionIdViews,
  method: httpMethod.get,
  url: `/API/metadata/v1/shares/custom_actions/${encodeURIComponent(context)}/${encodeURIComponent(actionId)}/views/`,
  params: { context, actionId },
  headers,
});

/**
 * `GET /v1/user/fields/`
 *
 * List the fields that can be accessed by a user
 *
 * Required roles:
 *  - can_read_metadata_fields
 *
 * Responses
 * - 200 - Returns a list of metadata fields
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 503 - Failed to retrieve user fields from search index
 *
 * Response {@link MetadataMetadataFieldsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_user_fields_}
 */
export const httpGetUserFields = (headers?: IconikApiHeaders) => ({
  id: MetadataHttpGetUserFields,
  method: httpMethod.get,
  url: '/API/metadata/v1/user/fields/',

  headers,
});

export interface MetadataHttpGetViewsQuery {
  /**
   * A comma separated list of fields to include in the response. For example: id,name,view_fields.use_as_facet
   *
   */
  include_fields?: string;
  /**
   * A comma separated list of fields to exclude from the response. For example: description,view_fields
   *
   */
  exclude_fields?: string;
}

/**
 * `GET /v1/views/`
 *
 * List the views defined in the system
 *
 * Required roles:
 *  - can_read_metadata_views
 *
 * Responses
 * - 200 - Returns a list of metadata views
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 503 - Failed to retrieve metadata views from search index
 *
 * Response {@link MetadataMetadataViewsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_views_}
 */
export const httpGetViews = (
  query?: MetadataHttpGetViewsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetViews,
  method: httpMethod.get,
  url: '/API/metadata/v1/views/',

  query,
  headers,
});

/**
 * `POST /v1/views/`
 *
 * Create a new view
 *
 * Required roles:
 *  - can_write_metadata_views
 *
 * Responses
 * - 201 - Returns a created view
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MetadataMetadataViewSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1_views_}
 */
export const httpPostViews = (
  body: MetadataMetadataViewCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostViews,
  method: httpMethod.post,
  url: '/API/metadata/v1/views/',

  body,
  headers,
});

export interface MetadataHttpPostViewsReindexQuery {
  /**
   * If true, the first batch of views is reindexed using the low priority queue. Later batches and the orphaned view cleanup use the normal metadata indexing queue.
   *
   */
  low_priority_indexing?: boolean;
  /**
   * If true, the request is a sync from another DC and the reindex is not synced back
   *
   */
  dc_sync?: boolean;
}

/**
 * `POST /v1/views/reindex/`
 *
 * Reindex all metadata views for the current domain
 *
 * Required roles:
 *  - can_reindex_metadata_views
 *
 * Responses
 * - 201 - Reindex has been scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1_views_reindex_}
 */
export const httpPostViewsReindex = (
  body: MetadataReindexMetadataViewSchema,
  query?: MetadataHttpPostViewsReindexQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostViewsReindex,
  method: httpMethod.post,
  url: '/API/metadata/v1/views/reindex/',

  body,
  query,
  headers,
});

/**
 * `DELETE /v1/views/{view_id}/`
 *
 * Delete a particular view by id
 *
 * Required roles:
 *  - can_delete_metadata_views
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/delete_v1_views__view_id__}
 */
export const httpDeleteViewsByViewId = (
  viewId: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpDeleteViewsByViewId,
  method: httpMethod.delete,
  url: `/API/metadata/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  headers,
});

export interface MetadataHttpGetViewsByViewIdQuery {
  merge_fields?: boolean;
}

/**
 * `GET /v1/views/{view_id}/`
 *
 * Returns a particular view by id
 *
 * Required roles:
 *  - can_read_metadata_views
 *
 * Responses
 * - 200 - Returns a view
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 * - 503 - Failed to retrieve metadata view from search index
 *
 * Response {@link MetadataMetadataViewSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1_views__view_id__}
 */
export const httpGetViewsByViewId = (
  viewId: string,
  query?: MetadataHttpGetViewsByViewIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetViewsByViewId,
  method: httpMethod.get,
  url: `/API/metadata/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  query,
  headers,
});

export type MetadataMetadataViewInputSchemaPartial =
  Partial<MetadataMetadataViewInputSchema>;

/**
 * `PATCH /v1/views/{view_id}/`
 *
 * Update view
 *
 * Required roles:
 *  - can_write_metadata_views
 *
 * Responses
 * - 200 - Returns an updated view
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * Response {@link MetadataMetadataViewSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/patch_v1_views__view_id__}
 */
export const httpPatchViewsByViewId = (
  viewId: string,
  body: MetadataMetadataViewInputSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPatchViewsByViewId,
  method: httpMethod.patch,
  url: `/API/metadata/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  body,
  headers,
});

/**
 * `PUT /v1/views/{view_id}/`
 *
 * Update view
 *
 * Required roles:
 *  - can_write_metadata_views
 *
 * Responses
 * - 200 - Returns an updated view
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * Response {@link MetadataMetadataViewSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1_views__view_id__}
 */
export const httpPutViewsByViewId = (
  viewId: string,
  body: MetadataMetadataViewInputSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutViewsByViewId,
  method: httpMethod.put,
  url: `/API/metadata/v1/views/${encodeURIComponent(viewId)}/`,
  params: { viewId },
  body,
  headers,
});

export interface MetadataHttpPostViewsByViewIdReindexQuery {
  /**
   * If true, the view is reindexed using the low priority queue
   */
  low_priority_indexing?: boolean;
  /**
   * If true, the request is a sync from another DC and the reindex is not synced back. If the view no longer exists it is removed from the index and the removal is still synced to the other DC, unless sync_to_another_dc is false in the request body.
   *
   */
  dc_sync?: boolean;
}

/**
 * `POST /v1/views/{view_id}/reindex/`
 *
 * Reindex metadata views
 *
 * Required roles:
 *  - can_reindex_metadata_views
 *
 * Responses
 * - 201 - Reindex has been scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1_views__view_id__reindex_}
 */
export const httpPostViewsByViewIdReindex = (
  viewId: string,
  body: MetadataReindexMetadataViewSchema,
  query?: MetadataHttpPostViewsByViewIdReindexQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostViewsByViewIdReindex,
  method: httpMethod.post,
  url: `/API/metadata/v1/views/${encodeURIComponent(viewId)}/reindex/`,
  params: { viewId },
  body,
  query,
  headers,
});

/**
 * `GET /v1/{object_type}/categories/`
 *
 * Get metadata categories
 *
 * Required roles:
 *  - can_read_metadata_categories
 *
 * Responses
 * - 200 - Returns metadata categories for an object
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link MetadataMetadataCategoriesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1__object_type__categories_}
 */
export const httpGetByObjectTypeCategories = (
  objectType: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetByObjectTypeCategories,
  method: httpMethod.get,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/categories/`,
  params: { objectType },
  headers,
});

/**
 * `POST /v1/{object_type}/categories/`
 *
 * Add a metadata category for an object type
 *
 * Required roles:
 *  - can_write_metadata_categories
 *
 * Responses
 * - 201 - Returns a metadata category
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 409 - A category with the same name and object_type already exists
 *
 * Response {@link MetadataMetadataCategorySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1__object_type__categories_}
 */
export const httpPostByObjectTypeCategories = (
  objectType: string,
  body: MetadataMetadataCategorySchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostByObjectTypeCategories,
  method: httpMethod.post,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/categories/`,
  params: { objectType },
  body,
  headers,
});

/**
 * `DELETE /v1/{object_type}/categories/{name}/`
 *
 * Delete metadata category by object type and category name
 *
 * Required roles:
 *  - can_delete_metadata_categories
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Default categories cannot be deleted
 * - 404 - Metadata category by object type and category name doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/delete_v1__object_type__categories__name__}
 */
export const httpDeleteByObjectTypeCategoriesByName = (
  objectType: string,
  name: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpDeleteByObjectTypeCategoriesByName,
  method: httpMethod.delete,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/categories/${encodeURIComponent(name)}/`,
  params: { objectType, name },
  headers,
});

/**
 * `GET /v1/{object_type}/categories/{name}/`
 *
 * Get metadata category by object type and category name
 *
 * Required roles:
 *  - can_read_metadata_categories
 *
 * Responses
 * - 200 - Returns metadata category by object type and category name
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata category by object type and category name doesn't exist
 *
 * Response {@link MetadataMetadataCategorySchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1__object_type__categories__name__}
 */
export const httpGetByObjectTypeCategoriesByName = (
  objectType: string,
  name: string,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetByObjectTypeCategoriesByName,
  method: httpMethod.get,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/categories/${encodeURIComponent(name)}/`,
  params: { objectType, name },
  headers,
});

/**
 * `PUT /v1/{object_type}/categories/{name}/`
 *
 * Edit metadata category for an object type
 *
 * Required roles:
 *  - can_write_metadata_categories
 *
 * Responses
 * - 200 - Returns a metadata category
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata category for this object type doesn't exist
 *
 * Response {@link MetadataMetadataCategorySchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1__object_type__categories__name__}
 */
export const httpPutByObjectTypeCategoriesByName = (
  objectType: string,
  name: string,
  body: MetadataMetadataCategorySchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutByObjectTypeCategoriesByName,
  method: httpMethod.put,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/categories/${encodeURIComponent(name)}/`,
  params: { objectType, name },
  body,
  headers,
});

export interface MetadataHttpGetByObjectTypeCategoriesByNameViewsQuery {
  ext_options?: boolean;
  writable_only?: boolean;
}

/**
 * `GET /v1/{object_type}/categories/{name}/views/`
 *
 * Get metadata views with field for object type and category
 *
 * Required roles:
 *  - can_read_metadata_categories
 *
 * Responses
 * - 200 - Returns metadata views with field for object type and category
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata views with field for object type and category doesn't exist
 *
 * Response {@link MetadataMetadataCategorySchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1__object_type__categories__name__views_}
 */
export const httpGetByObjectTypeCategoriesByNameViews = (
  objectType: string,
  name: string,
  query?: MetadataHttpGetByObjectTypeCategoriesByNameViewsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetByObjectTypeCategoriesByNameViews,
  method: httpMethod.get,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/categories/${encodeURIComponent(name)}/views/`,
  params: { objectType, name },
  query,
  headers,
});

/**
 * `PUT /v1/{object_type}/content/views/{view_id}/`
 *
 * Edit view metadata values for collection or saved search content.
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 202 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 * - 501 - Invalid object type
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1__object_type__content_views__view_id__}
 */
export const httpPutByObjectTypeContentViewsByViewId = (
  objectType: string,
  viewId: string,
  body: MetadataCollectionMetadataValuesBatchSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutByObjectTypeContentViewsByViewId,
  method: httpMethod.put,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/content/views/${encodeURIComponent(viewId)}/`,
  params: { objectType, viewId },
  body,
  headers,
});

/**
 * `POST /v1/{object_type}/views/{view_id}/`
 *
 * Add view metadata values for multiple objects (Assets, Collections or Segments)
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 202 - Batch metadata update was successfully scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/post_v1__object_type__views__view_id__}
 */
export const httpPostByObjectTypeViewsByViewId = (
  objectType: string,
  viewId: string,
  body: MetadataCreateMetadataValuesBatchSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPostByObjectTypeViewsByViewId,
  method: httpMethod.post,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/views/${encodeURIComponent(viewId)}/`,
  params: { objectType, viewId },
  body,
  headers,
});

/**
 * `PUT /v1/{object_type}/views/{view_id}/`
 *
 * Edit view metadata values for multiple objects (Assets, Collections or Segments)
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 202 - Batch metadata update was successfully scheduled
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1__object_type__views__view_id__}
 */
export const httpPutByObjectTypeViewsByViewId = (
  objectType: string,
  viewId: string,
  body: MetadataMetadataValuesBatchSchema,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutByObjectTypeViewsByViewId,
  method: httpMethod.put,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/views/${encodeURIComponent(viewId)}/`,
  params: { objectType, viewId },
  body,
  headers,
});

/**
 * Returns metadata values for the object if they exist
 */
export interface MetadataHttpGetByObjectTypeByObjectIdResponse {}

export interface MetadataHttpGetByObjectTypeByObjectIdQuery {
  check_if_subclip?: boolean;
  /**
   * Filter out metadata field values, for deleted fields
   */
  include_values_for_deleted_fields?: boolean;
}

/**
 * `GET /v1/{object_type}/{object_id}/`
 *
 * Get object metadata by object type and object ID
 *
 *
 * Responses
 * - 200 - Returns metadata values for the object if they exist
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata values for this object don't exist
 * - 503 - Failed to retrieve metadata views from search index
 *
 * Response {@link MetadataHttpGetByObjectTypeByObjectIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1__object_type___object_id__}
 */
export const httpGetByObjectTypeByObjectId = (
  objectType: string,
  objectId: string,
  query?: MetadataHttpGetByObjectTypeByObjectIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetByObjectTypeByObjectId,
  method: httpMethod.get,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
  params: { objectType, objectId },
  query,
  headers,
});

export interface MetadataHttpPutByObjectTypeByObjectIdQuery {
  check_if_subclip?: boolean;
  ignore_unchanged?: boolean;
  /**
   * Skip reindexing the asset or collection after the metadata update. Updates of a subclip that are redirected to its original segment still trigger segment reindexing.
   *
   */
  ignore_reindexing?: boolean;
}

/**
 * `PUT /v1/{object_type}/{object_id}/`
 *
 * Edit metadata values directly without a view. Admin access required.
 *
 *
 * Responses
 * - 200 - Returns created metadata values for the object
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - This endpoint is only available for admins
 *
 * Response {@link MetadataMetadataValuesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1__object_type___object_id__}
 */
export const httpPutByObjectTypeByObjectId = (
  objectType: string,
  objectId: string,
  body: MetadataMetadataValuesSchema,
  query?: MetadataHttpPutByObjectTypeByObjectIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutByObjectTypeByObjectId,
  method: httpMethod.put,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/`,
  params: { objectType, objectId },
  body,
  query,
  headers,
});

export interface MetadataHttpGetByObjectTypeByObjectIdViewsByViewIdQuery {
  check_if_subclip?: boolean;
  reencode_values_to_string?: boolean;
}

/**
 * `GET /v1/{object_type}/{object_id}/views/{view_id}/`
 *
 * Get object metadata by object type, object ID and view ID
 *
 * Required roles:
 *  - can_read_metadata_values
 *
 * Responses
 * - 200 - Returns metadata values for object and view if it exists
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata values for this object and view doesn't exist
 *
 * Response {@link MetadataMetadataValuesSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/get_v1__object_type___object_id__views__view_id__}
 */
export const httpGetByObjectTypeByObjectIdViewsByViewId = (
  objectType: string,
  objectId: string,
  viewId: string,
  query?: MetadataHttpGetByObjectTypeByObjectIdViewsByViewIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpGetByObjectTypeByObjectIdViewsByViewId,
  method: httpMethod.get,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/views/${encodeURIComponent(viewId)}/`,
  params: { objectType, objectId, viewId },
  query,
  headers,
});

export interface MetadataHttpPutByObjectTypeByObjectIdViewsByViewIdQuery {
  check_if_subclip?: boolean;
  ignore_unchanged?: boolean;
}

/**
 * `PUT /v1/{object_type}/{object_id}/views/{view_id}/`
 *
 * Edit view metadata values for a single object
 *
 * Required roles:
 *  - can_write_metadata_values
 *
 * Responses
 * - 200 - Returns created metadata values for object and view
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Metadata view doesn't exist
 *
 * Response {@link MetadataMetadataValuesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/metadata/spec/#/default/put_v1__object_type___object_id__views__view_id__}
 */
export const httpPutByObjectTypeByObjectIdViewsByViewId = (
  objectType: string,
  objectId: string,
  viewId: string,
  body: MetadataMetadataValuesSchema,
  query?: MetadataHttpPutByObjectTypeByObjectIdViewsByViewIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: MetadataHttpPutByObjectTypeByObjectIdViewsByViewId,
  method: httpMethod.put,
  url: `/API/metadata/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/views/${encodeURIComponent(viewId)}/`,
  params: { objectType, objectId, viewId },
  body,
  query,
  headers,
});
